import { Box, Button, Container, Paper, Typography } from "@mui/material";

import { useLazyGetSsoUrlQuery } from "../../store/services/authService";
import { useLocation } from "react-router-dom";

export default function Login() {
  const [getSsoUrl] = useLazyGetSsoUrlQuery();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const returnUrl = searchParams.get("returnUrl");

  const handleLogin = async () => {
    const ssoUrl = await getSsoUrl().unwrap();
    if (ssoUrl) {
      const state = `${window.location.origin}/login/callback?returnUrl=${returnUrl}`;
      window.location.href = ssoUrl.url + "&state=" + state;
    }
  };
  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        background:
          "linear-gradient(135deg, #005AA9 0%, #1E88E5 35%, #FF8F45 65%, #FF5F00 100%)",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 20,
          left: 40,
          opacity: 0.9,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            color: "white",
            fontWeight: "light",
            textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
          }}
        >
          Dalakraft
        </Typography>
      </Box>

      <Box
        sx={{
          position: "absolute",
          bottom: 20,
          right: 40,
          opacity: 0.9,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            color: "white",
            fontWeight: "light",
            textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
          }}
        >
          Enkla Elbolaget
        </Typography>
      </Box>

      <Container
        maxWidth="sm"
        sx={{
          textAlign: "center",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: "20px",
        }}
      >
        <Box sx={{ opacity: 0.9 }}>
          <Typography
            variant="h4"
            sx={{
              color: "white",
              fontWeight: "light",
              textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
            }}
          >
            Kraftvyn B2B
          </Typography>
        </Box>
        <Box
          sx={{
            mt: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Paper
            sx={{
              p: 4,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography component="h1" variant="h5">
              Logga in
            </Typography>
            <Button
              fullWidth
              variant="contained"
              onClick={handleLogin}
              sx={{ mt: 3 }}
            >
              Logga in med Microsoft
            </Button>
          </Paper>
        </Box>
      </Container>
    </Box>
  );
}
